export default __webpack_public_path__ + "static/media/om-token-migration.6f595c63.svg";